import React from 'react'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { Card } from '@mobi/component-library/Base/Card'
import { BetInfo } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/BetInfo'
import { Investment } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/Investment'
import { ShareBet } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/ShareBet'
import {
  getTicketLayoutType,
  getTicketStatus,
} from '@core/Areas/Account/Pages/Activity/Components/Ticket/helpers'
import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'

export const RaceCardTicket: React.FC<{ ticket: Ticket; isPending: boolean }> = ({
  ticket,
  isPending,
}) => {
  const status = getTicketStatus(ticket, isPending ? 'pending' : 'results')
  const ticketTypeLayout = getTicketLayoutType(ticket)

  return (
    <Card data-testid='race-card-ticket'>
      <BetInfo ticket={ticket} status={status} ticketLayoutType={ticketTypeLayout} />

      <Investment ticket={ticket} status={status} />

      <BetCard.Footer
        rightSection={
          <ShareBet
            ticket={ticket}
            activeTab={isPending ? 'pending' : 'results'}
            sourceLocation='race-card'
          />
        }
      />
    </Card>
  )
}
